import includes from "lodash/includes";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ModalGenericConfirmCancelContainer from "../../../Common/ModalGenericConfirmCancelContainer";
import EndreMiljogebyrModalForm from "../EndreMiljogebyrModalForm";

import { putStedsbeskrivelse } from "../../../../actions/commonActions";
import { addFlashMessage as addFlashMessageAction } from "../../../../actions/FlashMessagesAction";
import { getInternkoderMiljogebyr as getInternkoderMiljogebyrAction } from "../../../../actions/internkoderMiljogebyrActions";
import {
  getMiljogebyr as getMiljogebyrAction,
  getMiljogebyrerHistorikk as getMiljogebyrerHistorikkAction,
  putMiljogebyrer as putMiljogebyrerAction,
} from "../../../../actions/miljogebyrerActions";
import {
  getMiljogebyrEttersendelser as getMiljogebyrEttersendelserAction,
  postMiljogebyrEttersendelser as postMiljogebyrEttersendelserAction,
} from "../../../../actions/miljogebyrEttersendelserActions";
import { getMiljoleveringstyper as getMiljoleveringstyperAction } from "../../../../actions/miljoleveringstyperActions";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../../actions/overtredelseskoderMiljogebyrActions";

import { getOvertredelseskoderMiljogebyrAsDropDownListSearchFriendly } from "../../../../selectors/miljogebyrSelector";
import { getSelectOptionsEnhanced } from "../../../../selectors/selectOptionsSelector";

import { stateModified } from "../../../../utils/stateUtils";

import { commentHasToBeBetween } from "../../../../constants/ErrorMessages";
import {
  ettersendelsesrapportMaxLength,
  ettersendelsesrapportMinLength,
} from "../../../../constants/globals";

function buildInitialState(miljogebyr) {
  return {
    gateNavn: miljogebyr.gatenavn ? miljogebyr.gatenavn : "",
    gateNummer: miljogebyr.gatenummer ? miljogebyr.gatenummer : "",
    oppgang: miljogebyr.oppgang ? miljogebyr.oppgang : "",
    stedsBeskrivelseId: miljogebyr.stedsBeskrivelseId
      ? miljogebyr.stedsBeskrivelseId
      : "",
    bydel: miljogebyr.bydel ? miljogebyr.bydel : "",
    vedGate: miljogebyr.vedGate ? miljogebyr.vedGate : "",
    vedOppgang: miljogebyr.vedOppgang ? miljogebyr.vedOppgang : "",
    vedGateNummer: miljogebyr.vedGatenummer ? miljogebyr.vedGatenummer : "",
    mottaker: miljogebyr.mottaker ? miljogebyr.mottaker : "",
    fodsnrOrOrgnr: miljogebyr.mottakerId ? miljogebyr.mottakerId : "",
    mottakertypeId: miljogebyr.mottakertype ? miljogebyr.mottakertype : null,
    mottakerGate: miljogebyr.mottakerGate ? miljogebyr.mottakerGate : "",
    mottakerGateNummer: miljogebyr.mottakerGateNummer
      ? miljogebyr.mottakerGateNummer
      : "",
    mottakerPostnummer: miljogebyr.mottakerPostnummer
      ? miljogebyr.mottakerPostnummer
      : "",
    mottakerPoststed: miljogebyr.mottakerPostSted
      ? miljogebyr.mottakerPostSted
      : "",
    mottakerLand: miljogebyr.mottakerLand ? miljogebyr.mottakerLand : "",
    gnr: miljogebyr.gnr ? miljogebyr.gnr : null,
    bnr: miljogebyr.bnr ? miljogebyr.bnr : null,
    belop: miljogebyr.belop ? miljogebyr.belop : null,
    leveringstype: miljogebyr.leveringstype && miljogebyr.leveringstype.id,
    overtredelse1: miljogebyr.overtredelse1 && miljogebyr.overtredelse1.id,
    overtredelse2: miljogebyr.overtredelse2
      ? miljogebyr.overtredelse2.id
      : null,
    overtredelse3: miljogebyr.overtredelse3
      ? miljogebyr.overtredelse3.id
      : null,
    internkode1: miljogebyr.internkode1 ? miljogebyr.internkode1.id : null,
    internkode2: miljogebyr.internkode2 ? miljogebyr.internkode2.id : null,
    internkode3: miljogebyr.internkode3 ? miljogebyr.internkode3.id : null,
    ettersendelsesrapport: null,
    showEttersendelsesrapportTextArea: false,
    ettersendelsesrapportValidationErrorText: null,
    internkommentar: miljogebyr.internkommentar
      ? miljogebyr.internkommentar
      : "",
    kommentarTilMottaker: miljogebyr.kommentar ? miljogebyr.kommentar : "",
    stedModified: false,
    miljoModified: false,
    ettersendelsesrapportModified: false,
  };
}

const STEDS_BESKRIVELSE_PROPS = [
  "bydel",
  "gateNavn",
  "gateNummer",
  "oppgang",
  "vedGate",
  "vedGateNummer",
  "vedOppgang",
];

const MILJOGEBYR_PROPS = [
  "mottaker",
  "fodsnrOrOrgnr",
  "mottakertypeId",
  "mottakerGate",
  "mottakerGateNummer",
  "mottakerPostnummer",
  "mottakerLand",
  "mottakerPoststed",
  "gnr",
  "bnr",
  "leveringstype",
  "overtredelse1",
  "overtredelse2",
  "overtredelse3",
  "internkode1",
  "internkode2",
  "internkode3",
  "kommentarTilMottaker",
  "internkommentar",
  "belop",
];

export default function EndreMiljogebyrContainer() {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const mottakertyper = useSelector((state) =>
    getSelectOptionsEnhanced(state, "mottakertyper", "navn", "id"),
  );
  const leveringstyper = useSelector((state) =>
    getSelectOptionsEnhanced(state, "miljoleveringstyper", "navn", "id"),
  );
  const overtredelseskoder = useSelector(
    getOvertredelseskoderMiljogebyrAsDropDownListSearchFriendly,
  );
  const internkoder = useSelector((state) =>
    getSelectOptionsEnhanced(
      state,
      "internkoderMiljogebyr",
      "beskrivelse",
      "id",
    ),
  );
  const dispatch = useDispatch();

  const [formState, setFormState] = useState(() =>
    buildInitialState(miljogebyr),
  );
  const [initialState] = useState(() =>
    Object.freeze(buildInitialState(miljogebyr)),
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getMiljoleveringstyperAction());
    dispatch(getOvertredelseskoderMiljogebyrAction());
    dispatch(getInternkoderMiljogebyrAction());
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const { showEttersendelsesrapportTextArea, leveringstype } = formState;
    if (
      !showEttersendelsesrapportTextArea &&
      leveringstype === 3 &&
      miljogebyr &&
      miljogebyr.leveringstype &&
      miljogebyr.leveringstype.id !== leveringstype
    ) {
      setFormState((prev) => ({
        ...prev,
        showEttersendelsesrapportTextArea: true,
      }));
    } else if (
      showEttersendelsesrapportTextArea &&
      miljogebyr &&
      miljogebyr.leveringstype &&
      miljogebyr.leveringstype.id === leveringstype
    ) {
      setFormState((prev) => ({
        ...prev,
        showEttersendelsesrapportTextArea: false,
        ettersendelsesrapport: initialState.ettersendelsesrapport,
        ettersendelsesrapportValidationErrorText:
          initialState.ettersendelsesrapportValidationErrorText,
        ettersendelsesrapportModified:
          initialState.ettersendelsesrapportModified,
      }));
    }
  }, [formState.leveringstype]); // eslint-disable-line react-hooks/exhaustive-deps

  const parseNumberAndSetState = (name, value) => {
    if (name === "bnr" || name === "gnr" || name === "belop") {
      setFormState((prev) => ({ ...prev, [name]: Number(value) }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const areInputFieldsValidChange = (name, value) => {
    if (
      name === "ettersendelsesrapport" &&
      formState.ettersendelsesrapportValidationErrorText &&
      value &&
      value.length >= ettersendelsesrapportMinLength &&
      value.length <= ettersendelsesrapportMaxLength
    ) {
      setFormState((prev) => ({
        ...prev,
        ettersendelsesrapportValidationErrorText:
          initialState.ettersendelsesrapport,
      }));
    }
  };

  const checkStateIsModified = (name, val) => {
    const snapshot = formState;
    if (includes(STEDS_BESKRIVELSE_PROPS, name)) {
      stateModified(name, val, initialState, snapshot, "stedModified");
      setFormState((prev) => ({
        ...prev,
        stedModified: snapshot.stedModified,
      }));
    } else if (includes(MILJOGEBYR_PROPS, name)) {
      stateModified(name, val, initialState, snapshot, "miljoModified");
      setFormState((prev) => ({
        ...prev,
        miljoModified: snapshot.miljoModified,
      }));
    } else if (
      name === "ettersendelsesrapport" &&
      val !== initialState.ettersendelsesrapport
    ) {
      stateModified(
        name,
        val,
        initialState,
        snapshot,
        "ettersendelsesrapportModified",
      );
      setFormState((prev) => ({
        ...prev,
        ettersendelsesrapportModified: snapshot.ettersendelsesrapportModified,
      }));
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    parseNumberAndSetState(name, value);
    areInputFieldsValidChange(name, value);
    checkStateIsModified(name, value);
  };

  const handleBlur = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (typeof value === "string") value = value.trim();
    parseNumberAndSetState(name, value);
  };

  const setPropsToInitialState = () => {
    setFormState({ ...initialState });
  };

  const areInputFieldsValidSubmit = () => {
    const { showEttersendelsesrapportTextArea, ettersendelsesrapport } =
      formState;
    if (
      showEttersendelsesrapportTextArea &&
      (!ettersendelsesrapport ||
        ettersendelsesrapport.length < ettersendelsesrapportMinLength ||
        ettersendelsesrapport.length > ettersendelsesrapportMaxLength)
    ) {
      const ettersendelsesrapportValidationErrorText = commentHasToBeBetween(
        ettersendelsesrapportMinLength,
        ettersendelsesrapportMaxLength,
      );
      setFormState((prev) => ({
        ...prev,
        ettersendelsesrapportValidationErrorText,
      }));
      return false;
    }
    return true;
  };

  const handleApiCall = async (miljogebyrId) => {
    if (!areInputFieldsValidSubmit()) {
      return Promise.reject("Valideringsfeil");
    }
    const {
      stedsBeskrivelseId,
      stedModified,
      miljoModified,
      ettersendelsesrapportModified,
    } = formState;
    let putError = null;
    if (miljoModified && !putError) {
      const putMiljogebyrerData = await dispatch(
        putMiljogebyrerAction(miljogebyrId, formState),
      );
      putError = putMiljogebyrerData.resolved
        ? putError
        : putMiljogebyrerData.data;
    }
    if (ettersendelsesrapportModified && !putError) {
      await dispatch(
        postMiljogebyrEttersendelserAction(miljogebyr.id, {
          kommentar: formState.ettersendelsesrapport,
        }),
      )
        .then(() => dispatch(getMiljogebyrEttersendelserAction(miljogebyrId)))
        .catch((error) => (putError = error));
    }
    if (stedModified && !putError) {
      const putStedsbeskrivelseData = await dispatch(
        putStedsbeskrivelse(stedsBeskrivelseId, formState),
      );
      putError = putStedsbeskrivelseData.resolved
        ? putError
        : putStedsbeskrivelseData.data;
    }
    if (!miljoModified && !ettersendelsesrapportModified && !stedModified) {
      // ponytail: nothing changed → close silently, no flash
      return true;
    }
    if (putError) {
      dispatch(
        addFlashMessageAction({ type: "error", text: "Endring feilet" }),
      );
      return false;
    }
    dispatch(getMiljogebyrAction(miljogebyrId));
    await dispatch(getMiljogebyrerHistorikkAction(miljogebyrId));
    setFormState((prev) => ({
      ...prev,
      miljoModified: false,
      ettersendelsesrapportModified: false,
      stedModified: false,
    }));
    dispatch(
      addFlashMessageAction({ type: "success", text: "Endring fullført" }),
    );
    return true;
  };

  if (!miljogebyr.isMakulert) {
    return (
      <ModalGenericConfirmCancelContainer
        id={miljogebyr.id}
        className="miljogebyrDetailPutModal"
        modalTitle={`Endre miljøgebyr  ${miljogebyr.ileggelsesnummer}`}
        submitButtonText="Lagre endring"
        submittingButtonText="Lagrer endring..."
        handleConfirmClick={() => handleApiCall(miljogebyr.id)}
        handleCancelAndCloseClick={setPropsToInitialState}
        openModalComponentFunction={(endreModalProps) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={endreModalProps.openModal}
          >
            Endre miljøgebyr
          </Button>
        )}
      >
        <EndreMiljogebyrModalForm
          {...formState}
          warningText={
            miljogebyr.isSendtKemner
              ? "Dette miljøgebyret er allerede sendt til INE"
              : ""
          }
          showEttersendelsesrapportTextArea={
            formState.showEttersendelsesrapportTextArea
          }
          mottakertyper={mottakertyper}
          leveringstyper={leveringstyper}
          overtredelseskoder={overtredelseskoder}
          internkoder={internkoder}
          handleChange={handleChange}
          handleBlur={handleBlur}
        />
      </ModalGenericConfirmCancelContainer>
    );
  }
  return <span />;
}
